import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNil } from 'ramda';
import { useCallback, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import { twMerge } from 'tailwind-merge';
import { Text } from '../../atoms/Text';
import { useTestId, useToggle } from '../../hooks';
import { forwardRefWithName } from '../../utils';
function TooltipComponent(props, ref) {
    const { children, value, className, testId = 'tooltip', options, leaveDelay = 300 } = props, restProps = __rest(props, ["children", "value", "className", "testId", "options", "leaveDelay"]);
    const timeoutRef = useRef();
    const { state: isOpen, toggleOn, toggleOff } = useToggle(false);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, options);
    const tid = useTestId(testId, restProps);
    const classList = twMerge('tooltip', 'bg-white', 'p-4', 'rounded', 'mt-2', 'z-128', className);
    const onMouseEnter = useCallback(() => {
        clearTimeout(timeoutRef.current);
        toggleOn();
    }, [toggleOn]);
    const onMouseLeave = () => (timeoutRef.current = setTimeout(toggleOff, leaveDelay));
    return (_jsxs("div", Object.assign({ ref: ref }, restProps, tid(), { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: [_jsx("span", Object.assign({ ref: setReferenceElement }, tid('reference'), { children: children })), isOpen && !isNil(value) ? (_jsx("div", Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { className: classList }, tid('content'), { children: _jsx(Text, { variant: "bodyXS", children: value }) }))) : null] })));
}
export const Tooltip = forwardRefWithName(TooltipComponent);
//# sourceMappingURL=Tooltip.js.map